import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@panwds/react-ui';
import { useWizardContext } from './WizardContext.esm.js';

function NextButton({ children = "Next", ...passThrough }) {
    return (React.createElement(Button, { appearance: "primary", type: "submit", ...passThrough }, children));
}
function PrevButton({ children = "Previous", onClick, ...passThrough }) {
    const { gotoStep, state: { activeIndex }, } = useWizardContext();
    const { getValues } = useFormContext();
    return (React.createElement(Button, { onClick: (e) => {
            const values = getValues();
            gotoStep({
                next: Math.max(activeIndex - 1, 0),
                currentStep: { index: activeIndex, values },
            });
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }, ...passThrough }, children));
}

export { NextButton, PrevButton };
//# sourceMappingURL=Actions.esm.js.map
